module.exports = __webpack_public_path__ + "img/ae-hero-banner-mobile.ece11e47.png";